export class ConfigService {
  public static getHeaders() {
    const userStr = sessionStorage.getItem('user');
    let user: any = {accessToken: ''};
    if (userStr !== null && userStr.trim() !== '') {
      user = JSON.parse(userStr);
    }
    return {
      headers: {
        Authorization: user.accessToken,
      },
    };
  }
}
